// extracted by mini-css-extract-plugin
export default {"wrapper":"Subheader_wrapper__Ty0ML","img":"Subheader_img__cYjee","separator":"Subheader_separator__KlSg1"};